<template>
    <router-view/>
</template>

<script>
    export default {
        name: "Secenekler"
    }
</script>

<style scoped>

</style>